'use strict';

import React, { Component } from 'react';
import classNames from 'classnames';

const CollectionItemComponent = props => {
  let sub = '';
  if (props.data.displaySubtitle.length > 0) {
    sub = `(${props.data.displaySubtitle})`;
  }

  const classes = classNames('collection-item', {
    'collection-item--active': props.selectedCollection === props.data.name
  });


  return (
    <li
      className={classes}
      onClick={() => props.handleCollectionSelected(props.data.name)}
    >
      {props.data.displayName} {sub}
    </li>
  );
};

export default CollectionItemComponent;
